import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

export interface DateRangeSelectorDialogData {
  minDate?: Date;
  maxDate?: Date;
  beginDate: Date;
  endDate: Date;
}

@Component({
  selector: 'sales-ui-date-range-selector-dialog',
  templateUrl: './date-range-selector-dialog.component.html',
  styleUrls: ['./date-range-selector-dialog.component.scss'],
})
export class DateRangeSelectorDialogComponent {
  range: UntypedFormGroup;
  minDate: Date;
  maxDate: Date;

  constructor(
    private readonly ref: MatDialogRef<DateRangeSelectorDialogComponent, DateRangeSelectorDialogData>,
    @Inject(MAT_DIALOG_DATA) private readonly data: DateRangeSelectorDialogData,
  ) {
    this.minDate = this.data.minDate ? this.data.minDate : null;
    this.maxDate = this.data.maxDate ? this.data.maxDate : null;
    this.range = new FormGroup({
      start: new FormControl<Date | null>(this.data.beginDate),
      end: new FormControl<Date | null>(this.data.endDate),
    });
  }

  applyChanges(): void {
    const beginDate = this.range.controls.start.value;
    const endDate = this.range.controls.end.value;
    const start = moment(beginDate).startOf('day').toDate();
    const end = moment(endDate || beginDate)
      .endOf('day')
      .toDate();
    const dates: DateRangeSelectorDialogData = { beginDate: start, endDate: end };
    this.ref.close(dates);
  }
}
